import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Box,
    Typography,
    Alert,
    CircularProgress
} from '@mui/material';
import apiService from '../services/api';

const Auth = ({ onAuthenticated }) => {
    const [open, setOpen] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Check if user is already authenticated with JWT token
        if (apiService.isAuthenticated()) {
            // Just check if token exists, don't make API requests yet
            onAuthenticated(true);
        } else {
            setOpen(true);
            onAuthenticated(false);
        }
    }, [onAuthenticated]);

    const handleLogin = async () => {
        if (!username || !password) {
            setError('Please enter both username and password!');
            return;
        }

        try {
            setLoading(true);
            setError('');

            console.log('Attempting login with:', { username });
            console.log('API URL:', `${apiService.getApiBaseUrl()}/token`);

            const response = await apiService.login(username, password);
            console.log('Login successful:', response);

            setOpen(false);
            onAuthenticated(true);
            setLoading(false);
        } catch (err) {
            console.error('Login error:', err);
            console.error('Error details:', err.response?.data || 'No response data');
            console.error('Error status:', err.response?.status || 'No status code');

            // Handle different error scenarios
            if (err.response && err.response.status === 401) {
                setError('Invalid username or password');
            } else if (err.message && err.message.includes('Network Error')) {
                setError('Network error. Please check your connection and API URL.');
            } else {
                setError(`Login failed: ${err.response?.data?.detail || err.message || 'Unknown error'}`);
            }

            setLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleLogin();
        }
    };

    return (
        <Dialog open={open} onClose={() => { }} maxWidth="xs" fullWidth>
            <DialogTitle>
                <Typography variant="h5" component="div" align="center">
                    BrandSpark ® Trust Survey
                </Typography>
            </DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 2 }}>
                    {error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    )}
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Username"
                        type="text"
                        fullWidth
                        variant="outlined"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        onKeyPress={handleKeyPress}
                        disabled={loading}
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        margin="dense"
                        label="Password"
                        type="password"
                        fullWidth
                        variant="outlined"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyPress={handleKeyPress}
                        disabled={loading}
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 3 }}>
                <Button
                    onClick={handleLogin}
                    variant="contained"
                    color="primary"
                    fullWidth
                    disabled={loading}
                >
                    {loading ? <CircularProgress size={24} /> : 'Login'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default Auth;
